import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Channels } from '@/components/contact/channels'
import { ContactHero } from '@/components/contact/contact-hero'
import { LetterForm } from '@/components/contact/letter-form'

const Contact: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Contact'
                description='Write to Frieze about identity, typeface design, editorial, packaging or wayfinding. We reply within a couple of working days.'
            />

            <ContactHero />

            <div className='px-6 sm:px-12'>
                <div className='grid grid-cols-12 gap-x-6 gap-y-24 pb-8'>
                    <section id='letter' className='col-span-12 lg:col-span-7'>
                        <LetterForm />
                    </section>

                    <section
                        id='channels'
                        className='col-span-12 lg:col-start-9 lg:col-span-4 lg:border-l lg:border-fz-rule lg:pl-10'
                    >
                        <Channels />
                    </section>
                </div>
            </div>
        </Layout>
    )
}

export default Contact
